// if (document.querySelector(".side-nav .active")) {
//   var container = document.querySelector(".side-nav-wrapper > div");
//   var el = document.querySelector(".side-nav-wrapper .side-nav a.active");
//   var rect = el.getBoundingClientRect();

//   container.scrollTo({
//     top: rect.top - window.innerHeight / 2 - rect.height,
//     left: 0,
//     behavior: "smooth",
//   });
// }
import { showHideProgress } from "./scrollprogress";
const links = document.querySelectorAll(".side-nav a.x-link");
const contentContainer = document.querySelector("#m-content");
links.forEach((link) => {
  link.addEventListener("click", (e) => {
    e.preventDefault();
    loadContent(link);
  });
});

async function loadContent(link) {
  const url = link.getAttribute("href");
  window.scrollTo(0, 0);
  const req = new Request(url, {
    headers: new Headers({
      "X-Requested-With": "XMLHttpRequest",
    }),
  });
  const response = await fetch(req);
  if (response.ok) {
    const json = await response.json();
    let btn;

    if (json.html) {
      setActiveItem(link);
      contentContainer.innerHTML = json.html;
      const state = { page_id: json.id };
      history.pushState(state, "", url);
    }
    if (json.scrollIndicator == true) {
      showHideProgress();
    } else {
      document.getElementById("progress").style.opacity = 0;
    }
  } else {
  }
}

// Toggle submenus
const submenuToggles = document.querySelectorAll(".side-nav .submenu-toggle");
submenuToggles.forEach((btn, index) => {
  const label = btn.nextElementSibling;
  const content = btn.closest("li").querySelector(".submenu");
  label.id = "exp-header-" + index;
  content.id = "exp-content-" + index;
  content.setAttribute("aria-labelledby", label.id);
  btn.setAttribute("aria-label", "Aus-/Einklappen");
  btn.setAttribute("aria-controls", content.id);
  btn.classList.add("transition-all");

  if (label.classList.contains("active") || content.querySelector("a.active")) {
    expandSubmenu(btn);
  } else {
    collapseSubmenu(btn);
  }

  btn.addEventListener("click", (e) => {
    e.preventDefault();
    // collapseAllSubmenus(btn);
    if (btn.getAttribute("aria-expanded") == "true") {
      collapseSubmenu(btn);
    } else {
      expandSubmenu(btn, true);
    }
  });
});

// toggle submenu on non-link-item click
const additionalToggles = document.querySelectorAll(
  ".side-nav .toggle-submenu"
);
additionalToggles.forEach((el) => {
  el.addEventListener("click", (e) => {
    const btn = el.closest("div").querySelector(".submenu-toggle");
    if (btn && btn.getAttribute("aria-expanded") != "true")
    btn.click();
  });
});

function collapseAllSubmenus(exceptBtn = false, exceptLink = false) {
  let parentBtns = getParentBtns(exceptBtn);
  if (exceptLink) parentBtns = getParentBtns(exceptLink);

  submenuToggles.forEach((btn) => {
    let collapse = true;
    if (parentBtns && parentBtns.includes(btn)) collapse = false;
    if (btn == exceptBtn) collapse = false;
    if (collapse) collapseSubmenu(btn);
  });
}

function getParentBtns(btn = false, allBtns = []) {
  if (!btn) return false;
  let parentUl = btn.closest("ul");
  if (parentUl) {
    let parentLi = parentUl.closest("li");
    if (parentLi) {
      let parentBtn = parentLi.querySelector(".submenu-toggle");
      allBtns.push(parentBtn);

      if (parentBtn.closest("ul")) {
        getParentBtns(parentBtn, allBtns);
      }
    }
  }
  return allBtns;
}

function collapseSubmenu(btn) {
  const content = btn.closest("li").querySelector(".submenu");
  btn.setAttribute("aria-expanded", "false");
  btn.classList.remove("rotate-90", "text-green");
  content.classList.add("hidden");

  collapseChildMenus(btn);
}

function collapseChildMenus(btn) {
  const openBtns = btn
    .closest("li")
    .querySelectorAll('.submenu-toggle[aria-expanded="true"]');
  openBtns.forEach((btn) => {
    collapseSubmenu(btn);
  });
}

function expandSubmenu(btn, scroll = false) {
  let parentBtns = getParentBtns(btn);
  if (parentBtns.length) {
    parentBtns.forEach((b) => {
      expandSubmenu(b);
    });
  }
  const content = btn.closest("li").querySelector(".submenu");
  btn.setAttribute("aria-expanded", "true");
  btn.classList.add("rotate-90", "text-green");
  content.classList.remove("hidden");

  if (scroll) {
    setTimeout(() => {
      if (!isInViewport(btn.closest("li"))) {
        content.scrollIntoView({ behavior: "smooth", block: "end" });
      }
    }, 50);
  }
}

function setActiveItem(link) {
  document.querySelectorAll(".side-nav a.active").forEach((el) => {
    el.classList.remove("active");
  });
  link.classList.add("active");

  let btn;
  if ((btn = link.parentElement.querySelector(".submenu-toggle"))) {
    expandSubmenu(btn, true);
    // collapseAllSubmenus(btn);
  } else {
    // collapseAllSubmenus(false, link);
  }
}

function isInViewport(element) {
  const rect = element.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}
